import { Module } from "vuex";
import { RootState } from "@/store";

import state, { AuthenticationState } from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
    state,
    mutations,
    actions,
    getters,
} as Module<AuthenticationState, RootState>;
